import { store } from "@betacrew/jars-flux";
import { componentKey, setGuidedFormList, setLoadingState } from "./RecommendFormSlice";
import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import { RECOMMEND_FORM_LOADING_STATES } from "./Constants";
import FormsDataService from "../../../../services/FormsDataService";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../components/toast/constants";


export const { getGuidedForms } = {
    getGuidedForms: (payload) => {
        return {
            type: "RECOMMEND_FORM/GET_GUIDED_FORM_LIST",
            payload
        }
    }
}


function* getGuidedFormsAsync(action) {
    try {
        yield put(setLoadingState({ state: RECOMMEND_FORM_LOADING_STATES.GET_GUIDED_FORMS_LOADING}));
        const response = yield FormsDataService.GetGuidedFormList();
        if (response.data) {
            if (response?.data?.Status === 0) {
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            } else if (response?.data?.Data?.length) {
                yield put(setGuidedFormList(response.data.Data));
            }
        }
    } catch (error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: RECOMMEND_FORM_LOADING_STATES.GET_GUIDED_FORMS_READY }))
    }
}


function* rootSaga() {
    yield all([
        takeLeading(getGuidedForms().type, getGuidedFormsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);